var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Students"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M49.8999 57C49.8999 51.1063 47.4556 45.454 43.1048 41.2865C38.7539 37.119 32.8529 34.7778 26.6999 34.7778M26.6999 34.7778C20.5469 34.7778 14.6459 37.119 10.2951 41.2865C5.94427 45.454 3.5 51.1063 3.5 57M26.6999 34.7778C34.7081 34.7778 41.1999 28.5595 41.1999 20.8889C41.1999 13.2183 34.7081 7 26.6999 7C18.6918 7 12.2 13.2183 12.2 20.8889C12.2 28.5595 18.6918 34.7778 26.6999 34.7778ZM61.5 54.2221C61.5 44.861 55.7 36.1665 49.9 31.9999C51.8065 30.6298 53.3311 28.8307 54.3387 26.7617C55.3463 24.6928 55.8059 22.4178 55.6769 20.1382C55.5478 17.8586 54.8341 15.6445 53.5989 13.6921C52.3637 11.7396 50.645 10.1089 48.595 8.94431",
    stroke: "#605DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/students.0eb10f2ffeb668adbc24ee02a2db3e1f.svg";
export { ForwardRef as ReactComponent };